// services/country.service.ts

import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private apiUrl = eps.auth.countryApi
  constructor(private http: HttpClient) {}

  getCountries(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/all`)
  }
}
